import { render, staticRenderFns } from "./BaseTable.vue?vue&type=template&id=5dcbfc02&scoped=true&"
import script from "./BaseTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseTable.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseTable.vue?vue&type=style&index=0&id=5dcbfc02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcbfc02",
  null
  
)

export default component.exports